import { Link, useNavigate } from "react-router-dom";
import "./settingMagasin.css";
import { useContext, useState, useEffect } from "react";
import axios from "axios";
import { MagasinContext } from "../../../Context/MagasinContext";
import { NewSideBarMagasins } from "../../NewSidebarMagasin";

export default function SettingMagasin() {
  const magasinContext = useContext(MagasinContext);
  const MagasinId = localStorage.getItem("MagasinId");
  const MagasinName = localStorage.getItem("MagasinName");
  const id = MagasinId || magasinContext.id?.id;
  const navigate = useNavigate();
  const handleGoBack = () => navigate(-1);

  const [muteNotif, setMuteNotif] = useState(false);
  const [hidePreview, setHidePreview] = useState(false);
  const [enCompte, setEnCompte] = useState(false);
  const [loadingEnCompte, setLoadingEnCompte] = useState(false);

  useEffect(() => {
    if (!id) return;
    axios
      .get(`${process.env.REACT_APP_PHP_APP_URL}/magasins/${id}/check-en-compte`)
      .then((res) => {
        setEnCompte(Boolean(res.data?.en_compte));
      })
      .catch((err) => {
        console.error("Error fetching en_compte setting:", err);
      });
  }, [id]);

  const toggleEnCompte = async () => {
    if (!id || loadingEnCompte) return;
    const nextVal = !enCompte;
    setLoadingEnCompte(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_PHP_APP_URL}/magasins/${id}/toggle-en-compte`,
        { en_compte: nextVal }
      );
      setEnCompte(Boolean(res.data?.en_compte));
      localStorage.setItem("en_compte", nextVal ? "1" : "0");
    } catch (err) {
      console.error("Error toggling en_compte:", err);
    } finally {
      setLoadingEnCompte(false);
    }
  };

  return (
    <>
      <NewSideBarMagasins />
      <div className="setting-page-wrapper">
        <div className="setting-page-inner">
          {/* Back */}
          <button className="setting-back-btn" onClick={handleGoBack}>
            <i className="bi bi-arrow-left"></i> Retour
          </button>

          {/* Header */}
          <div className="setting-header">
            <h1 className="setting-title">Paramètres</h1>
          </div>

          {/* En Compte Mode Section */}
          <div className="setting-section">
            <div className="setting-section-title">Mode En Compte (Crédit Magasin)</div>

            <div className="setting-toggle">
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span className="setting-toggle-label">
                  Activer le mode En Compte
                </span>
                <span style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>
                  Permet de choisir un magasin fournisseur lors de la connexion pour acheter avec son solde de crédit.
                </span>
              </div>
              <button
                className={`setting-toggle-switch ${enCompte ? "active" : ""}`}
                onClick={toggleEnCompte}
                disabled={loadingEnCompte}
              />
            </div>

            <Link
              className="setting-link"
              to={`/magasins/${id}/en-compte`}
            >
              <div className="setting-link-icon" style={{ background: '#fef3c7', color: '#d97706' }}>
                <i className="bi bi-wallet2"></i>
              </div>
              <span className="setting-link-text">
                Gérer les magasins clients en compte
              </span>
              <i className="bi bi-chevron-right setting-link-arrow"></i>
            </Link>
          </div>

          {/* Account Section */}
          <div className="setting-section">
            <div className="setting-section-title">Compte</div>

            <Link
              className="setting-link"
              to={`/magasins/${id}/paramétres/change-email`}
            >
              <div className="setting-link-icon">
                <i className="bi bi-envelope"></i>
              </div>
              <span className="setting-link-text">
                Changer l'adresse email
              </span>
              <i className="bi bi-chevron-right setting-link-arrow"></i>
            </Link>

            <Link
              className="setting-link"
              to={`/magasins/${id}/paramétres/change-mot-de-passe`}
            >
              <div className="setting-link-icon">
                <i className="bi bi-key"></i>
              </div>
              <span className="setting-link-text">
                Changer le mot de passe
              </span>
              <i className="bi bi-chevron-right setting-link-arrow"></i>
            </Link>
          </div>

          {/* Notification Section */}
          <div className="setting-section">
            <div className="setting-section-title">Notifications</div>

            <div className="setting-toggle">
              <span className="setting-toggle-label">
                Ne pas recevoir des notifications sonores
              </span>
              <button
                className={`setting-toggle-switch ${muteNotif ? "active" : ""}`}
                onClick={() => setMuteNotif(!muteNotif)}
              />
            </div>

            <div className="setting-toggle">
              <span className="setting-toggle-label">
                Ne pas afficher des aperçus de notifications
              </span>
              <button
                className={`setting-toggle-switch ${hidePreview ? "active" : ""}`}
                onClick={() => setHidePreview(!hidePreview)}
              />
            </div>
          </div>

          {/* Information Section */}
          <div className="setting-section">
            <div className="setting-section-title">Information</div>

            <a href="#" className="setting-info-link">
              <i className="bi bi-question-circle" style={{ marginRight: '8px', color: '#F5A623' }}></i>
              Besoin d'aide ?
            </a>
            <a href="#" className="setting-info-link">
              <i className="bi bi-shield-check" style={{ marginRight: '8px', color: '#F5A623' }}></i>
              Politiques de confidentialité et conditions d'utilisation
            </a>
          </div>
        </div>
      </div>
    </>
  );
}